import React from "react";
import { ADDRESS_NUDGE_TOOLTIP_STATUS, AddressInfo, AddressNudgeConfig } from "@swiggy-private/cart-types";

export interface CartAddressState {
    isFetchingAddressList: boolean;
    addressList: AddressInfo[];
    isErrorFetchingAddressList: boolean;
    isInvalidCartData: boolean;
    showAddressList: boolean;
    addressNudgeConfig: AddressNudgeConfig;
}

export interface CartAddressContextValue {
    cartAddressState: CartAddressState;
    setCartAddressState: React.Dispatch<React.SetStateAction<CartAddressState>>;
}

export const INITIAL_CART_ADDRESS_CONTEXT_VALUE: CartAddressContextValue = {
    cartAddressState: {
        isFetchingAddressList: false,
        isErrorFetchingAddressList: false,
        addressList: [],
        isInvalidCartData: false,
        showAddressList: false,
        addressNudgeConfig: {
            isAddressNudgeXpEnabled: false,
            showAddressNudgeIcon: false,
            addressNudgeTooltipStatus: ADDRESS_NUDGE_TOOLTIP_STATUS.NOT_SHOWN,
        },
    },
    setCartAddressState: () => void 0,
};

export const CartAddressContext = React.createContext<CartAddressContextValue>(INITIAL_CART_ADDRESS_CONTEXT_VALUE);

if (__DEV__) {
    CartAddressContext.displayName = "CartAddressContext";
}
